import { WebSocketAction } from 'constants/web-socket-action';
import { getServer } from 'helpers/get-server';
import { type IncomingResponseMessage } from 'interfaces/incoming-message';
import type { Properties } from 'interfaces/property';
import { type UpdateThreadPropertiesEvent } from 'interfaces/web-socket-events';

import { sendEvent } from './send-event';

/**
 * @see https://platform.text.com/docs/messaging/agent-chat-api/rtm-reference#update-thread-properties
 */
export async function updateThreadProperties(
  chatId: string,
  threadId: string,
  properties: Properties
): Promise<IncomingResponseMessage<void>> {
  const event: UpdateThreadPropertiesEvent = {
    action: WebSocketAction.UpdateThreadProperties,
    payload: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      chat_id: chatId,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      thread_id: threadId,
      properties,
    },
    version: '3.5',
  };

  return await sendEvent<void>(getServer(), event);
}
